import { Moment } from "moment";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo, useState } from "react";

import { useBookingBarContext } from "../booking_bar_provider";
import { DaySeparator } from "./day_separator";
import { SplitBookingModal } from "./split_booking_modal";
import css from "./split_mode_overlay.module.scss";

const BORDER_WIDTH = 2;

export const SplitModeOverlay = (): JSX.Element | null => {
  const {
    bar: { width, start, end }
  } = useBookingBarContext();
  const { utc, formatISODate } = useDateFormatter();
  const [selectedSplitDate, setSelectedSplitDate] = useState<Moment | null>(null);

  const { dayWidth, bookingDays } = useMemo(() => {
    const daySeparatorsCount = utc(formatISODate(utc(end))).diff(utc(formatISODate(utc(start))), "days");
    return {
      dayWidth: width / (daySeparatorsCount + 1),
      bookingDays: Array.from(Array(daySeparatorsCount).keys())
    };
  }, [width, start, end, utc]);

  return (
    <div className={css.root} style={{ padding: `0 ${dayWidth / 2 - BORDER_WIDTH}px` }}>
      {bookingDays.map((dayIndex) => {
        const splitDate = utc(start).add(dayIndex, "days");
        return (
          <DaySeparator
            key={dayIndex}
            date={splitDate}
            width={dayWidth}
            onClick={() => {
              setSelectedSplitDate(splitDate);
            }}
          />
        );
      })}
      {selectedSplitDate !== null && (
        <SplitBookingModal splitDate={selectedSplitDate} onClose={() => setSelectedSplitDate(null)} />
      )}
    </div>
  );
};
